import { compose } from 'redux';

import { WithFetchDatasByIdFromCMS, WithFetchDatasByIdFromCMSInputProps, WithCMSSEO } from 'modules/shared-cms/hocs';

import { VoyageLoader } from './voyage.loader';
import { query } from './voyage.query';
import { VoyagePageProps } from './voyage.types';

export const Enhancer = compose<React.ComponentType<WithFetchDatasByIdFromCMSInputProps>>(
    WithFetchDatasByIdFromCMS<VoyagePageProps>(query, VoyageLoader, 'findListeVoyageContent'),
    WithCMSSEO(),
);
